import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var SubScriptIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1303 35.7369C36.1303 35.7369 36.1303 35.7369 36.1303 35.7369L35.4637 36.4036C35.0096 36.8577 34.2733 36.8577 33.8192 36.4036C33.3651 35.9495 33.3651 35.2133 33.8192 34.7592L34.4859 34.0925C36.1958 32.3826 38.9475 32.3826 40.6575 34.0925C42.3674 35.8024 42.3674 38.5542 40.6575 40.2641L37.2471 43.6744H41.4631C42.1053 43.6744 42.6259 44.195 42.6259 44.8372C42.6259 45.4794 42.1053 46 41.4631 46H34.8895C34.316 46 33.8547 45.6529 33.6507 45.204C33.4455 44.7526 33.4811 44.1256 33.9443 43.6883L39.013 38.6196C39.8147 37.8179 39.8147 36.5387 39.013 35.7369C38.2113 34.9352 36.932 34.9352 36.1303 35.7369Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53291 2C7.1751 2 7.6957 2.5206 7.6957 3.16279V12.5736C7.6957 17.1252 11.3922 20.8217 15.9438 20.8217C20.4954 20.8217 24.1918 17.1252 24.1918 12.5736V3.16279C24.1918 2.5206 24.7124 2 25.3546 2C25.9968 2 26.5174 2.5206 26.5174 3.16279V12.5736C26.5174 18.4096 21.7797 23.1473 15.9438 23.1473C10.1078 23.1473 5.37012 18.4096 5.37012 12.5736V3.16279C5.37012 2.5206 5.89072 2 6.53291 2Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3546 2C25.9968 2 26.5174 2.5206 26.5174 3.16279V33.876C26.5174 39.712 21.7797 44.4496 15.9438 44.4496C13.0167 44.4496 10.3838 43.2627 8.47038 41.3493C8.01628 40.8953 8.01628 40.159 8.47038 39.7049C8.92448 39.2508 9.66072 39.2508 10.1148 39.7049C11.6123 41.2024 13.6615 42.124 15.9438 42.124C20.4954 42.124 24.1918 38.4276 24.1918 33.876V3.16279C24.1918 2.5206 24.7124 2 25.3546 2Z"
  }));
});
SubScriptIcon.displayName = 'SubScriptIcon';
SubScriptIcon.defaultProps = {
  'aria-label': 'SubScript'
};
export default SubScriptIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/SubScriptIcon/index.js
// module id = 1948
// module chunks = 12